// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yOH-","inner":"Footer_inner__1ZS7L"};